import React from 'react';
import ReactDOM from 'react-dom/client';
import ParticlesBooking from './ParticlesBooking';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ParticlesBooking />
        </React.StrictMode>
        );
